import { render, staticRenderFns } from "./ElementShowSubelementsTab.vue?vue&type=template&id=5bd0eaef"
import script from "./ElementShowSubelementsTab.vue?vue&type=script&lang=ts"
export * from "./ElementShowSubelementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports